export default String.raw`
{% if config.B2B -%}
    <div class="wishlist-container wishlist-global-container-js">
        <div class="page-padding">
            {% include 'partials/wishlist/wishlists-list.html' -%}
        </div>
    </div>
{% else -%}
    {% assign view = 'no-set' -%}

    {% assign whatPrice = translations.Brutto | Downcase -%}

    {% if customer.Cart.SubtotalPrices -%}
        {% assign whatPrice = translations.Netto | Downcase -%}
    {% endif -%}
<div class="wishlist-container parent-container-js">
    <div class="page-padding">
        {% if customer.WishListCount > 0 -%}
        <div class="wishlist-container__header">
            <div class="navigation-header">
                <a class="pure-button" aria-label="homePage" href="{{ page.BaseHref }}{{ config.DefinedPages.Home }}">
                    <svg width="24" height="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#long-arrow-left-{{settings.iconStyle}}"></use>
                    </svg>
                </a>
                {{ translations.WishList }}
            </div>
            {% include 'partials/product/simple-add-to-cart.html' with -1 -%}
        </div>
        {% endif -%}
        <div class="wishlist-container-js">
            <div class="serial-adding-validation-message-js container-to-hide-js hidden-js message-container">
                <button class="close-button hide-container-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
                </button>
                <p>{{translations.SerialAddingToCartFail}}</p>
                <div class="message-container message-bar-content-js"></div>
            </div>
            <section class="view-container-js products-list-js parent-container-js {{view}}-view-js" data-template="partials/wishlist/wishlists-list.html">
                {% include 'partials/wishlist/wishlists-list.html' -%}
            </section>
        </div>
    </div>
</div>
{% endif -%}
`